import { render, staticRenderFns } from "./user-group-icon.vue?vue&type=template&id=11ee92f4"
import script from "./user-group-icon.vue?vue&type=script&lang=js"
export * from "./user-group-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports